var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.colecao,"item-text":function (ref) {
	var codigo = ref.codigo;
	var descricao = ref.descricao;

	return (codigo + " - " + descricao);
},"item-value":"codigo","data-cy":"seletor-de-cfop"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }